import axios from 'axios';

export function submitRequest(request) {
  return new Promise(function(resolve, reject) {
    axios.post(process.env.API_URL+'/request',JSON.stringify(request), {
      headers: {
        'Content-Type': 'application/json',
      }

    })
      .then(function(response) {
        let data = response.data;
        resolve(data);
      })
      .catch(function(err){
        reject(err);
      })
  })

}

export function getRequest(id) {
  return new Promise(function(resolve, reject) {
    axios.get(process.env.API_URL+'/request?id=' + id, {
      headers: {
        'Content-Type': 'application/json',
      }

    })
      .then(function(response) {
        let data = response.data;
        resolve(data);
      })
      .catch(function(err){
        reject(err);
      })
  })

}



// WEBPACK FOOTER //
// ./src/api/request.js